// extracted by mini-css-extract-plugin
export var container = "_5m-0";
export var error = "_5m-9";
export var label = "_5m-5";
export var light = "_5m-6";
export var md = "_5m-3";
export var sm = "_5m-2";
export var thin = "_5m-8";
export var thinBold = "_5m-7";
export var vertical = "_5m-4";
export var xs = "_5m-1";